import { Link } from "react-router-dom";

const Documentation = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-6">
        <Link to="/" className="text-primary hover:underline">&larr; Back Home</Link>
      </div>
      <h1 className="text-3xl font-bold mb-6">Documentation</h1>
      <div className="prose prose-gray max-w-none">
        <h2 className="text-2xl font-semibold mt-6 mb-4">Getting Started</h2>
        <p>Welcome to the UPnGOTrainerPad documentation. Here you'll find everything you need to know about using our platform.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">Features</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Training Management</li>
          <li>Progress Tracking</li>
          <li>Performance Analytics</li>
          <li>Team Collaboration</li>
        </ul>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">Support</h2>
        <p>If you need help, please contact our support team at:</p>
        <p>Email: info@upngoTrainerPad.co.uk</p>
      </div>
    </div>
  );
};

export default Documentation;